__turbopack_context__.v({
  "applyMemCard": "u0-acW_applyMemCard",
  "bounce": "u0-acW_bounce",
  "elementDivider": "u0-acW_elementDivider",
  "fadeIn": "u0-acW_fadeIn",
  "mask": "u0-acW_mask",
  "memCta": "u0-acW_memCta",
  "root": "u0-acW_root",
  "search": "u0-acW_search",
  "searchBtn": "u0-acW_searchBtn",
  "searchCard": "u0-acW_searchCard",
  "searchFood": "u0-acW_searchFood",
  "searchFoodOverlay": "u0-acW_searchFoodOverlay",
  "suggestions": "u0-acW_suggestions",
});
